import { createFileRoute } from '@tanstack/react-router';

import { OverviewPage } from '@/features/commercial/overview-page';

export const Route = createFileRoute('/_app/projects/$projectId/commercial/overview')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <OverviewPage projectId={projectId} />;
}
